import React, { memo } from 'react';

import type { TProps } from './models';
import { UrlMapperContext as Context } from './context';

/**
 * Provider: Провайдер нужен для виджета UrlMapper
 * */
export const UrlMapperContext = memo(({ children, urlMap }: TProps) => {
    return <Context.Provider value={urlMap}>{children}</Context.Provider>;
});
